"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class NoteModel {
    constructor(cache) {
        this.setNotes = async (noteValues) => this.cache.setObject(NoteModel.NOTES_DB, noteValues).asPromise();
        this.getNote = async (customerId) => {
            const notes = (await this.cache
                .getObject(NoteModel.NOTES_DB)
                .asPromise());
            return notes[customerId];
        };
        this.putNote = async (customerId, note) => {
            const notes = await this.getNotes();
            notes[customerId] = note;
            return this.setNotes(notes);
        };
        this.getNotes = async () => {
            return (await this.cache.getObject(NoteModel.NOTES_DB).asPromise());
        };
        this.cache = cache;
    }
}
NoteModel.NOTES_DB = "Mock.Notes";
exports.default = NoteModel;
//# sourceMappingURL=NoteModel.js.map